import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';
import { addressBlockSchema } from '@/shared/ui/AddressBlock/model';

export const weaponPlaceOfResidenceBaseSchema = z.object({
  registeredNewAddress: addressBlockSchema,
  declaredNewDocRent: documentDataSchema,
});
